import React, { Component } from 'react'
import MyButton from '../../util/MyButton'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { ignoreOpinion, unignoreOpinion } from '../../redux/actions/dataActions'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export class IgnoreButton extends Component {
    ignoredOpinion = () => {
        if(this.props.user.ignores && 
            this.props.user.ignores.find(
                ignore => ignore.wreckID === this.props.wreckID))
          return true;
        else return false;
      }
      ignoreOpinion = () => {
        this.props.ignoreOpinion(this.props.wreckID)
      }
      unignoreOpinion = () => {
        this.props.unignoreOpinion(this.props.wreckID)
      };
    render() {
        const { authenticated } = this.props.user;
        const ignoreButton = !authenticated ? (
            <Link to='/login'>
                <MyButton tip='hmmmm'>    
                  <FontAwesomeIcon icon="blind" />        
                </MyButton>
            </Link>
          ) : (
            this.ignoredOpinion() ? (
              <MyButton tip='ignore' onClick={this.unignoreOpinion}>
                <FontAwesomeIcon icon="blind" color='#BF2604' />
            </MyButton>
            ) : (
              <MyButton tip='hmmmm' onClick={this.ignoreOpinion}>
                <FontAwesomeIcon icon="blind" />

            </MyButton>
            )
          );
        return ignoreButton;
    }
}

IgnoreButton.propTypes = {
    user: PropTypes.object.isRequired,
    wreckID: PropTypes.string.isRequired,
    ignoreOpinion: PropTypes.func.isRequired,
    unignoreOpinion: PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({
    user: state.user
  })

const mapActionsToProps = {
    ignoreOpinion,
    unignoreOpinion
  }

export default connect(mapStateToProps, mapActionsToProps)(IgnoreButton)
